export default __webpack_public_path__ + "static/media/html5-original.c28bc668.svg";